export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27')
];

export const server_loads = [];

export const dictionary = {
		"/": [3],
		"/[locale]": [~4,[2]],
		"/[locale]/blog": [~5,[2]],
		"/[locale]/blog/[slug]": [~6,[2]],
		"/[locale]/contact": [~7,[2]],
		"/[locale]/destinations": [~8,[2]],
		"/[locale]/destinations/[slug]": [~9,[2]],
		"/[locale]/dining": [~10,[2]],
		"/[locale]/dining/[slug]": [~11,[2]],
		"/[locale]/events": [~12,[2]],
		"/[locale]/events/[slug]": [~13,[2]],
		"/[locale]/facilities": [~14,[2]],
		"/[locale]/facilities/[slug]": [~15,[2]],
		"/[locale]/faq": [~16,[2]],
		"/[locale]/gallery": [~17,[2]],
		"/[locale]/offers": [~18,[2]],
		"/[locale]/offers/[slug]": [~19,[2]],
		"/[locale]/rooms": [~20,[2]],
		"/[locale]/rooms/[slug]": [~21,[2]],
		"/[locale]/weddings": [~22,[2]],
		"/[locale]/wellness": [~23,[2]],
		"/[locale]/wellness/[slug]": [~24,[2]],
		"/[locale]/wellness/[slug]/[child]": [~25,[2]],
		"/[locale]/wellness/[slug]/[child]/[grandchild]": [~26,[2]],
		"/[locale]/[guestinfo]": [~27,[2]]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
	
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.svelte';